var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"shadow-none"},[_c('div',[_c('h6',[_vm._v("新密碼")]),_c('textboxVue',{attrs:{"type":"password"}}),_c('h6',[_vm._v("重複新密碼")]),_c('textboxVue',{attrs:{"type":"password"}}),_c('b-button',{staticClass:"f-right",attrs:{"variant":"danger"}},[_vm._v(" 確定 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }